import type { FaireProductEntity } from "../../entity_types/product";

export const p_xnyh5mcvfk: FaireProductEntity = {
  token: "p_xnyh5mcvfk",
  type: "product",
  name: "Christian themed waterproof stickers",
  brandName: "Ella Blue",
  imageUrl:
    "https://cdn.faire.com/fastly/1a40acdd8bdddc808bedcd7eac8b55028b75225d0f412759ad38f98d711350e9.jpeg",
  priceDollars: 0.18,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/e007ee1f14a4550eadc0e13fceb7e038bac4aa1bcecc3bf2fa1baafdb9f54bf6.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
